import { BaseFactory } from '../base.factory';
import { Station } from '@/modules/module/model/server/station';

export class StationFactory extends BaseFactory {

    constructor() {
      super(process.env.VUE_APP_API_URL);
    }

    public getStations = async () => {
      const path = `/location`;
      const result = await this.get(path) as Array<Station>;
      const sortedREsult = result
      .map(item => ({ ...item })) // Cria uma cópia de cada objeto para evitar mutação
      .sort((a, b) => (a.label && b.label ? a.label.localeCompare(b.label) : 0));
      return sortedREsult;
  }
}
